import { useRef, useEffect } from 'react';
export default function useSupercedingTimer() {
    var delayedAction = useRef(null);
    var clearSupercedingTimeout = function () {
        if (delayedAction.current) {
            clearTimeout(delayedAction.current);
            delayedAction.current = null;
        }
    };
    var updateTimeout = function (cb, timeout) {
        if (delayedAction.current) {
            clearTimeout(delayedAction.current);
        }
        delayedAction.current = setTimeout(cb, timeout);
    };
    // The return value of the effect is a function, so it will be called only on unmount
    useEffect(function () { return clearSupercedingTimeout; }, []);
    return { updateTimeout: updateTimeout, clearSupercedingTimeout: clearSupercedingTimeout };
}
//# sourceMappingURL=use-superceding-timer.js.map